import Vue from "vue";
// require('es6-promise').polyfill();
// var axios = require('axios');
import axios from "axios";
import store from "@/core/store/index";
import iView from "view-design";
import router from "@/router/index";
import global from "@/core/global/global";
import SparkMD5 from "spark-md5";
import JSEncrypt from "jsencrypt";
const isDev = !process.env.NODE_ENV === "development"; //true为开发环境
// 创建唯一 公钥 用于加密
var encryptStr = new JSEncrypt();
// 设置 加密公钥（正常从getPK接口获取，此处固定，如果需要改成接口获取，需要在请求拦截器中验证是否已拿到加密公钥，没有的话先获取加密公钥再添加 cnsign参数）
encryptStr.setPublicKey("MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAj1YbgGwvllFenGuQOkG0ToCn7HvtCBSSJ3N2Xs72hOxVU/SZgnh6zCa/9jtse6jZjNIyaXd3A3LN4iTbb/andtKZ2VrhY9GgSTlpGwgZxTqhAXTS1+DN/fIw43gsllbspFoeKkbzKyh7rGN5hXdHnDj8PytAWn3cK+emXgSeEc4Mj0LTV8CZM8AWhJ/deoer6pi5oggHUPuM2wY8RqhSfYuvZkza2I0Eghi8AUL97HbbKjm6Y6sz7qkh0nEKiU19O/asfI/qvxYejUC5KEugieXzES8Auoa2h8UOiN/sc2uah2o32QG2mT76CsL/dTHwhzOFz3JvjBug8VSuNF9hYwIDAQAB");

//let baseURL = "http://pubadmin.cnknowledge.com";
//let baseURL = "http://47.93.50.49:8093";
//if(location.host.indexOf("47.") != -1) {
//	baseURL = "http://47.93.50.49:8093"
//}
//else if(location.host.indexOf(".49") != -1) {
//	baseURL = "http://47.93.50.49:8093"
//}
//else if(location.host.indexOf(":80") != -1) {
//	baseURL = "/apis"
//}
let ajaxconfig = {
  // 基础url前缀
  baseURL: isDev ? "/apis" : "",
  //设置超时时间 原设置5分钟/300000 -> 改为2分钟
  timeout: 120000,
  //返回数据类型
  responseType: "json", // default
  //请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
  url: "/",

  // 请求方法同上
  method: "get", // default

  transformRequest: [
    function (data) {
      // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
      //data = axios.stringify(data);
      if (data.type == "formdata") {
        var formdata = new FormData();
        for (var n in data) {
          console.log(n);
          if (n != "type") {
            formdata.append(n, data[n]);
          }
        }

        return formdata;
      }

      return data;
    },
  ],

  transformResponse: [
    function (data) {
      // 这里提前处理返回的数据

      if (typeof data == "string") {
        data = JSON.parse(data);
      }
      return data;
    },
  ],

  // 请求头信息
  headers: {
    "Content-Type": "application/x-www-form-urlencoded", //application/json application/x-www-form-urlencoded,
  },

  //parameter参数
  params: {},

  //post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
  data: {},

  withCredentials: false, //当我们把此配置项设置成默认配置项并且设置成true的时候，axios就可以设置cookies了。
};

// 中文知识网新增参数 获取公网Ip地址接口(借助三方接口) 环境上不需要加前缀

let instance = axios.create(ajaxconfig);

//请求列表数据
function queryData(options, callBack) {
  var authorization = ""; //从session中取出token
  if (sessionStorage.getItem("userInfo")) {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo")); //取出sesion
    authorization = userInfo.token;
  } else {
    authorization = "";
  }

  //必须基本设置请求参数
  // 发测试使用
  var dev = "/tsg-admin";
  //	var dev = '';
  if (!isDev) {
    if (options.url.indexOf("txpy-web") != -1) {
      dev = global.global.url2.replace("/txpy-web", "");
    } else if (options.url.indexOf("tsg-admin") != -1) {
      dev = global.global.url.replace("/tsg-admin", "");
    } else if (options.url.indexOf("tsg-author") != -1) {
      dev = global.global.url3.replace("/tsg-author", "");
    } else {
      dev = global.global.url3.replace("/zw-chat", "");
    }
  }
  let url = dev + options.url || "";
  let method = options.method || ajaxconfig.method; //"get" "post"  "put" ，默认请求get

  let dataType = options.dataType || "";
  let isParseStringJSON = options["jsonString"];
  let isToken = options["isToken"];
  //扩展基本配置项
  let myConfig = options.baseConfing || {}; //{}

  let config = _.defaultsDeep({}, myConfig);
  config.method = method;

  let cnsign =
    Math.floor(10000000 + Math.random() * 90000000) +
    "zwjt8081!@#DF*F&^SKD" +
    new Date().getTime();
  instance.defaults.headers["cn-sign"] = encryptStr.encrypt(cnsign)
  instance.defaults.headers["timer"] = new Date().getTime()

  //获取服务端数据
  if (
    method == "post" ||
    method == "put" ||
    method == "patch" ||
    method == "delete"
  ) {

    //POST提交数据时必选参数
    let potsData = options.data || {}; //{firstName: 'Fred',lastName: 'FlintStone'}

    if (method == "post" && dataType == "formData") {
      config.headers = options.headers;
      let cnsign =
        Math.floor(10000000 + Math.random() * 90000000) +
        "zwjt8081!@#DF*F&^SKD" +
        new Date().getTime();
      config.headers["cn-sign"] = encryptStr.encrypt(cnsign)
      instance.defaults.headers["timer"] = new Date().getTime()
      callBack(instance);
      return instance[method].bind(instance, url, potsData, config);
    }

    if (_.isObject(potsData)) {
      if (typeof isParseStringJSON != "undefined") {
        setAjaxQuestHeader("Content-Type", "application/json");
        potsData = JSON.stringify(potsData);
      } else {
        setAjaxQuestHeader("Content-Type", "application/x-www-form-urlencoded");
        potsData = serializeParams(potsData, dataType);
      }
    }
    instance.defaults.headers["timer"] = new Date().getTime()
    instance.defaults.headers["cn-sign"] = encryptStr.encrypt(cnsign)
    callBack(instance);
    if (method == "delete") {
      potsData = {
        data: potsData,
      };
    }
    //		if(authorization && typeof isToken != 'isToken') {
    //			instance.defaults.headers.authorization = authorization;
    //		} else {
    //			delete instance.defaults.headers.authorization
    //		}
    if (authorization && !isToken) {
      instance.defaults.headers.authorization = authorization;
    } else {
      delete instance.defaults.headers.authorization;
    }

    return instance[method].bind(instance, url, potsData, config);
  } else {
    //GET提交数据时必选参数
    let myParams = options.params || {}; //{params: {ID: 12345}} || '/user?ID=12345'
    myParams = Object.assign({}, myParams, {
      // mathRand: Math.random() * 100000000000000000
      time: new Date().getTime(),
    });
    config.params = myParams;
    instance.defaults.headers["timer"] = new Date().getTime();
    instance.defaults.headers["cn-sign"] = encryptStr.encrypt(cnsign)
    callBack(instance);
    if (authorization && !isToken) {
      instance.defaults.headers.authorization = authorization;
    } else {
      delete instance.defaults.headers.authorization;
    }
    return instance[method].bind(instance, url, config);
  }
}

//JSON序列化传入参数形式
function serializeParams(params, type) {
  if (!params) return;
  let obj = {};
  if (type == "JSON") {
    if (!_.isString(params)) return;
    if (params.indexOf("&") > -1) {
      let splits = params.split("&");
      splits.forEach(function (v, k) {
        let key = v.split("=")[0] || k;
        let val = v.split("=")[1] || undefined;
        obj[key] = val;
      });
      return obj;
    }
  } else {
    if (!_.isObject(params)) {
      if (!_.isObject(JSON.parse(params))) {
        return;
      } else {
        params = JSON.parse(params);
      }
    }
    obj = [];
    _.forEach(params, function (v, k) {
      v = !v ? "" : v;
      let val = k + "=" + v;
      obj.push(val);
    });
    return obj.join("&");
  }
}

//请求前改变请求头源参数
function setAjaxQuestHeader(key, v) {
  ajaxconfig["headers"][key] = v;
  instance = axios.create(ajaxconfig);
}

let ajax = function (option) {
  return queryData(option, function (instance) {
    // 拦截器
    //请求响应

    instance.interceptors.request.use(
      async (config) => {

        if (sessionStorage.getItem("userInfo")) {
          var userInfo = JSON.parse(sessionStorage.getItem("userInfo")); //取出sesion
          const token = userInfo.token;
          if (token) {
            config.headers.common["token"] = token;
            let ip = sessionStorage.getItem("webIp");
            let timestamp = new Date().getTime();
            let nonce = ip + "-" + timestamp;

            let sign = token + nonce;
            let spark = new SparkMD5();
            spark.append(sign);
            let signMd5 = spark.end();
            config.headers["zw-nonce"] = nonce;
            config.headers["zw-sign"] = signMd5;
          }
        }
        config.headers["rsa"] = "no";

        iView.LoadingBar.start();
        // 公钥前端写死
        // var pubKey = window.sessionStorage.getItem("trip");
        // if (pubKey) {

        //   encryptStr.setPublicKey(pubKey); // 设置 加密公钥
        // }
        return config;
      },
      (error) => { }
    );
    //响应拦截器
    instance.interceptors.response.use(
      (config) => {
        //iView.LoadingBar.start();
        if (config.headers.authorization) {
          //存入token
          var jsonStr = JSON.stringify({
            token: config.headers.authorization,
          });
          sessionStorage.setItem("userInfo", jsonStr);
        }
        // config.setHeader('Access-Control-Allow-Origin', 'http://192.168.1.11:8081');

        if (!config.data == null) {
          if (config.data.code == "90004" || config.data.code == "90007") {
            iView.Message.destroy();
            iView.Message.warning("登录超时，请重新登录");
            setTimeout(function () {
              location.href = location.pathname + "#/loginAdmin";
            }, 3000);
            return;
          }
          config.data = config.data || JSON.parse(config.request.responseText);
        }
        iView.LoadingBar.finish();
        return config;
      },
      (error) => {
        //token 验证失败
        // iView.LoadingBar.finish();
        console.log(error)
        if (error.response.status == 504) {
          iView.Message.destroy();
          iView.Message.warning("连接超时，请稍后再试");
        } else if (
          error.response.status == 500 ||
          error.response.status == 502 ||
          error.response.status == 404
        ) {
          iView.Message.destroy();
          iView.Message.warning("数据加载失败，请稍后再试");
        } else if (error.response.status == 400) {
          iView.Message.destroy();
          iView.Message.warning("请求失败，请稍后再试");
        } else if (error.response.status == 401) {
          iView.Message.destroy();
          iView.Message.warning("登录超时，请重新登录");
          setTimeout(function () {
            location.href = location.pathname + "#/loginAdmin";
          }, 2000);
        } else {
          return error.response;
        }
      }
    );
  })();
};

export default ajax;



// WEBPACK FOOTER //
// ./src/core/api/config/http.js